(function($, Drupal, cookies) {
  Drupal.behaviors.accessibility = {
    attach: function (context, settings) {
      // get current value
      //var $text_size = $.cookie('a-text-size');
      var $text_size = cookies.get('a-text-size');
      
      if(typeof $text_size !== 'undefined') {
        $('.inner_sec p').css('font-size', $text_size)
          .css('line-height', $text_size);
      }

      //var $letter_spacing = $.cookie('a-letter-spacing');
      var $letter_spacing = cookies.get('a-letter-spacing');

      if(typeof $letter_spacing !== 'undefined') {
        $('.inner_sec p').css('letter-spacing', $letter_spacing);
      }
    }
  }
})(jQuery, Drupal, window.Cookies)
